import { CornermarkListUrlSortField } from "@saleor/cornermarks/urls";
import { CornerMarkSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: CornermarkListUrlSortField
): CornerMarkSortField {
  switch (sort) {
    case CornermarkListUrlSortField.name:
      return CornerMarkSortField.ID;
    case CornermarkListUrlSortField.text:
      return CornerMarkSortField.NAME;
    case CornermarkListUrlSortField.created:
      return CornerMarkSortField.CREATED;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
